export enum StatusEnum {
  Passed = 1,
  Failed = 2,
  Unknown = 3,
  InProgress = 4,
  NotProvided = 5,
}
